import { gql } from '@apollo/client';

export const getActivityHistoryQuery = gql`
    query GetActivityHistory($startAtHashKey: String, $startAtSortKey: DateTimeISO, $pageSize: Int!) {
        eventLogs(orderBy: "descending", startAtHashKey: $startAtHashKey, startAtSortKey: $startAtSortKey, take: $pageSize) {
            id
            createdAt
            eventType
            timeOfDay
            questCompleted {
                questId
            }
            questMetricIncreased {
                questId
                addedValue
                questMetricType
            }
            goalCompleted {
                goalId
                currencyEarned
                levelCompleted
            }
            rewardPurchased {
                rewardId
                currencyPaid
            }
        }
    }
`;
